// make id = `lang:slug`

export const getLearnMoreLinks = (basePath:string, sectionId:string) =>{
    const links:{route:string, slug:string}[] = [];
    LEARN_MORE_DIR.forEach(section =>{
        if(section.id === sectionId){
            section.sub.forEach(topic => {
                links.push({
                    route: basePath + topic.path,
                    slug: renderTitleSlug(sectionId, topic.path),
                })
            })
        }
    })
    return links;
}

const renderTitleSlug = (sectionId:string, route:string) => {
    return [
        'lm_title',
        sectionId,
        route
      ].join(':')
}


const sanitizePaths = () =>{
    const allPaths = [];
    LEARN_MORE_DIR.forEach(section =>{
        section.sub.forEach(topic => {
            topic.path = topic.id;
            // logTitleSlug(section.id, topic.path)
            allPaths.push(section.id +':' + topic.path)
            if (topic.sub){
                topic.sub.forEach(subtopic => {
                    subtopic.path = [topic.path, subtopic.id].join(':');
                    allPaths.push(section.id +':' + subtopic.path)
                    // logTitleSlug(section.id, subtopic.path)
                })
            }
        })
    });
    // console.log('allPaths', allPaths)
}

interface ILearnMoreSection {
    id: string,
    isLocked: boolean,
    sub: ILearnMoreTopic[],
}
interface ILearnMoreTopic {
    id: string,
    caption: string,
    path?:string,
    sub?: ILearnMoreTopic[],
    toggled?: boolean;
}

export const LEARN_MORE_DIR:ILearnMoreSection[] = [
    {
        id: 'applicant',
        isLocked: true,
        sub: [
            {caption: 'x', id:'test_windows', sub:[
                // {caption:'x?', id:'for_me'},
                // {caption:'x?', id:'whats_on'},
                // {caption:'x?', id:'how_do_i_pass'},
                // {caption:'x?', id:'how_long'},
                // {caption:'x?', id:'cost'},
                // {caption:'x?', id:'how_many_times'},
                // {caption:'x?', id:'marking'},
            ], toggled: false},
            
            {caption: 'x', id:'about', sub:[
                {caption:'x?', id:'for_me'},
                {caption:'x?', id:'overview'},
                {caption:'x?', id:'pedagogy_comp'},
                {caption:'x?', id:'math_comp'},
                // {caption:'x?', id:'whats_on'},
                {caption:'x?', id:'how_do_i_pass'},
                {caption:'x?', id:'how_long'},
                {caption:'x?', id:'cost'},
                {caption:'x?', id:'how_many_times'},
                {caption:'x?', id:'marking'},

            ], toggled: false},
            {caption: 'x', id:'before', sub:[
              {caption:'x?', id:'math_cont_res'},
              {caption:'x?', id:'ped_res'},
              {caption:'x?', id:'form_sheet'},
              {caption:'x?', id:'practice'},
              {caption:'x?', id:'tech_req_remote'},
              // {caption:'x?', id:'for_me'},
              // {caption:'x?', id:'whats_on'},
              // {caption:'x?', id:'how_do_i_pass'},
              // {caption:'x?', id:'how_long'},
              // {caption:'x?', id:'cost'},
              // {caption:'x?', id:'how_many_times'},
              // {caption:'x?', id:'marking'},

          ], toggled: false},
            {caption: 'x', id:'register', sub:[
                {caption:'x?', id:'get_app_num'},
                {caption:'x?', id:'get_loc'},
                // {caption:'x?', id:'register'},
                {caption:'x?', id:'create_accnt'},
                {caption:'x?', id:'book'},
                {caption:'x?', id:'cancel_test_session'},
                {caption:'x?', id:'tech_req_remote'},
                // {caption:'x?', id:'oct_id'},
                // {caption:'x?', id:'no_oct_id'},
                // {caption:'x?', id:'where'},
                // {caption:'x?', id:'when'},
                // {caption:'x?', id:'register_multiple'},
                // {caption:'x?', id:'waiting_list_join'},
                // {caption:'x?', id:'current_teachers'},
                // {caption:'x?', id:'no_session'},
                // {caption:'x?', id:'remote_req'},
            ], toggled: false},
            // {caption: 'x', id:'prepare', sub:[
            //     {caption:'x?', id:'whats_on_the_test'},
            //     {caption:'x', id:'sample_questions'},
            // ]},
            {caption: 'x', id:'testday', sub:[
            //   {caption:'x?', id:'test_details'},
              {caption:'x?', id:'verify_identity'},
              {caption:'x?', id:'verify_identity_refugees'},
              {caption:'x?', id:'tools_and_materials'},
              {caption:'x?', id:'arrival_time'},
              {caption:'x?', id:'attestation'},
              {caption:'x?', id:'inperson_instructions'},
              {caption:'x' , id:'remote_instructions'}, 
            //   {caption:'x?', id:'bring'},
            //   {caption:'x?', id:'photo_id_problem'},
            //   {caption:'x?', id:'photo_id_name'},
            //   {caption:'x?', id:'what_happens'},
            //   {caption:'x?', id:'miss'},
            //   {caption:'x?', id:'late'},
            //   {caption:'x', id:'personals'},
            ], toggled: false},
            {caption: 'x', id:'after_test', sub:[
              {caption:'x?', id:'report_expl'},
              {caption:'x?', id:'not_yet'},
              {caption:'x?', id:'filling_appeal'},
              // {caption:'x?', id:'passed'},
              // {caption:'x?', id:'not_yet'},
              // {caption:'x?', id:'partial_success'},
            ], toggled: false},
            // {caption: 'x', id:'results', sub:[
            //   {caption:'x?', id:'passed'},
            //   {caption:'x?', id:'not_yet'},
            //   {caption:'x?', id:'partial_success'},
            // ]},
            {caption: 'x', id:'access_accomm', sub: [
              {caption:'x?', id:'accomm'},
              {caption:'x?', id:'accomm_req'},
            ], toggled: false},
            {caption: 'x', id:'academic_misconduct', toggled: false},
            {caption: 'x', id:'faq', sub: [
               {caption:'x?', id:'faq_about'},
               {caption:'x?', id:'faq_registration'},
               {caption:'x?', id:'faq_access_accomm'},
               {caption:'x?', id:'faq_preparation'},
               {caption:'x?', id:'faq_after_the_test'},
            ], toggled: false},
            {caption: 'x', id:'resources', toggled: false},
            {caption: 'x)', id:'webinars', toggled: false},
            {caption: 'x', id:'land_knowledge', toggled: false},
            // {caption: 'x)', id:'faq_fieldtest'},
        ]
    },
    {
        id: 'testadmin',
        isLocked: true,
        sub: [
            {caption:'x', id:'about'},
            {caption:'x', id:'tech', },
            {caption:'x', id:'access_accomm', },
            {caption:'x', id:'create_test', sub:[
                {caption:'x?', id:'how_to_begin'},
                {caption:'x?', id:'test_window'},
                {caption:'x?', id:'create_test_session'},
                {caption:'x?', id:'restricted_session'},
                {caption:'x?', id:'multiple_sessions'},
                {caption:'x?', id:'after_creating'},
                {caption:'x', id:'adjusting_capacity'},
            ]},
            {caption:'x', id:'outside_faculty'},
            {caption:'x', id:'before'},
            {caption:'x', id:'on_test_day', sub:[
                {caption:'x', id:'start'},
                {caption:'x', id:'photo_id'},
                {caption:'x', id:'late'},
                {caption:'x', id:'extending'},
                {caption:'x', id:'closing'},
                {caption:'x', id:'before_they_leave'},
            ]},
            {caption:'x)', id:'faq'},
        ]
    },
];



sanitizePaths();
// temp1.map(t => `'${t}'`+': `\n\n\n`,').join('\n')